import formatPhoneNumber from "@/utilities/functions/format-phone-number";
import { z } from "zod";

// form zod validation schema
export const loginSchema = z.object({
  email: z.string().email({ message: "Please enter a valid email" }),
  password: z.string().min(1, { message: "Please enter your password" }),
  rememberMe: z.boolean().optional(),
});

export const agencyLoginSchema = z.object({
  phone: z
    .string({ message: "Please enter a valid phone number" })
    .trim() // Removes leading & trailing spaces
    .transform((val) => {
      const format = formatPhoneNumber(val);
      return format.replace(/\s+/g, "");
    }) // Removes all spaces
    .refine((val) => val.length === 8, { message: "Please enter a valid phone number" }),
});

// generate form types from zod validation schema
export type LoginSchema = z.infer<typeof loginSchema>;

export type AgencyLoginSchema = z.infer<typeof agencyLoginSchema>;
